import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { householdSchema } from '@/features/households/schema';
import { FormInput } from '@/components/forms/FormInput';
import { FormSelect } from '@/components/forms/FormSelect';
import { FormProvider } from 'react-hook-form';
import { Stack, Button } from '@mui/joy';

export function HouseholdForm({ data, save, saveResult, saveButton }) {
  const form = useForm({
    defaultValues: data,
    resolver: yupResolver(householdSchema)
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(save)}>
        <Stack gap={4}>
          <FormInput 
            name="name" 
            label="Household Name" 
            placeholder="Enter your household name" 
          />
          <FormInput 
            name="members" 
            label="Number of Members" 
            type="number"
            inputProps={{ min: 1 }}
          />
          <FormSelect
            name="week_start_day"
            label="Week starts on"
            options={[              
              { value: 1, label: 'Monday' },
              { value: 2, label: 'Tuesday' },
              { value: 3, label: 'Wednesday' },
              { value: 4, label: 'Thursday' },
              { value: 5, label: 'Friday' },
              { value: 6, label: 'Saturday' },
              { value: 0, label: 'Sunday' },
            ]}
          />
        </Stack>
        <Button 
          loading={saveResult.isLoading} 
          type="submit" 
          size={saveButton.size} 
          fullWidth={saveButton.fullWidth}
          sx={{mt: saveButton.mt}}
        >
          {saveButton.label}
        </Button>
      </form>
    </FormProvider>
  );
}
